
import Vue from "vue";
import AppUploadDocument from "./UploadDocument.vue";
import AppAwsFileEntry from "./AwsFileEntry.vue";
import { AwsDocumentState } from "@/utils/aws-documents-state";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>AwsDocumentState,
			required: true
		},
		edit: Boolean
	},
	methods: {
		downloadToAddFile(file:File){
			let link = document.createElement("a");
			let url = URL.createObjectURL(file);
			link.href = url;
			link.download = file.name;
			link.target = "_blank";
			link.click();
			URL.revokeObjectURL(url);
		},
		deleteToAddFile(file:File){
			let i = this.state.toAddFiles.indexOf(file);
			if (i == -1) return;
			this.state.toAddFiles.splice(i, 1);
		},
		onFile(file:File){
			this.state.toAddFiles.push(file);
		},
		openToAddFile(file:File){
			let url = URL.createObjectURL(file);
			window.open(url, "_blank");
			URL.revokeObjectURL(url);
		}
	},
	components: {
		AppUploadDocument,
		AppAwsFileEntry
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
